import React, { Component } from 'react';
import { Modal } from "react-bootstrap"
import Loader from 'react-loader-spinner'

import { connect} from "remx";

import broker from '../../utils/broker'
import authStore from '../../stores/auth';
import dataStore from '../../stores/data';

import _data_pie from '../DataTraffic/_data_pie';
import Sidebar from './Sidebar';

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"


class Home extends Component {

    constructor(props) {
        super(props);
    
        this.options = {

        }
        this.state = {
          reload:false,
          loading: false,
          data_traffic : {},
          chart_pie : [],
          rate: {},
          pekerjaan_off :[],
          top_10 :[],
          data_pelanggan: [],
          modal_ping : false,
          nama_ping : '',
          alamat_ip_ping : '',
          loading_ping : false,
          data_ping_1 : null,
          data_ping_2 : null,
          data_ping_3 : null,
          data_ping_4 : null,
          data_ping_5 : null,
        }
        this.modalPing = this.modalPing.bind(this);
        this.checkPing = this.checkPing.bind(this);
        this.ping = this.ping.bind(this);

      }

    getDataPelanggan(){
        this.setState({loading : true})
        let url = 'pelanggan_dashboard'
                            +'?q='
                            +'&klasifikasi_id='+this.props.data_klasifikasi.klasifikasi_id
                            +'&kategori_id='+this.props.data_klasifikasi.kategori_id
                            +'&sub_klasifikasi_id='+this.props.data_klasifikasi.sub_klasifikasi_id;

        broker.fetchSupport.get(url)
        .then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({data_pelanggan : data, loading: false})
            } else {

            }
        }).catch(err => {
            
        });
    }

    componentDidMount(){
        var addScript = document.createElement('script');
        addScript.setAttribute('src', '/assets/js/dashforge.filemgr.js');
        document.body.appendChild(addScript);
        if (this.props.data_klasifikasi.kategori_id) {
            this.getDataPelanggan();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.data_klasifikasi !== prevProps.data_klasifikasi) {
            this.getDataPelanggan()
        }
    }

    modalPing(data){
        this.setState({data_ping_1 : null, data_ping_2 : null, data_ping_3 : null, data_ping_4 : null, data_ping_5 : null});
        this.setState({nama_ping : data.nama_pelanggan, alamat_ip_ping : data.alamat_ip, modal_ping : true});
    }

    checkPing(){
        this.setState({data_ping_1 : null, data_ping_2 : null, data_ping_3 : null, data_ping_4 : null, data_ping_5 : null, loading_ping: true});
        setTimeout(() => {
            this.ping("data_ping_1")
        }, 1000);

        setTimeout(() => {
            this.ping("data_ping_2")
        }, 1000*2);

        setTimeout(() => {
            this.ping("data_ping_3")
        }, 1000*3);

        setTimeout(() => {
            this.ping("data_ping_4")
        }, 1000*4);

        setTimeout(() => {
            this.ping("data_ping_5")
            this.setState({loading_ping : false})
        }, 1000*5);

        
    }

    ping(data_ping) {
        broker.fetchSupport.post('/check_ping', {
            ping_ip : this.state.alamat_ip_ping
        }).then(res => {
            const { data } = res;
            if (data.status === true) {
                const val = (data.data.length > 0) ? data.data : this.state.alamat_ip_ping + ' - Destination Host Unreachable';
                this.setState({[data_ping] : val});
            }
        });
    }

    generateContent(){
        // console.log("generate")
        var data = this.state.data_pelanggan;
        let return_content = [];
        for (var i=0;i<data.length;i+=5){
            const id_1 = (data[i]) ? data[i] : "";
            const id_2 = (data[i+1]) ? data[i+1] : "";
            const id_3 = (data[i+2]) ? data[i+2] : "";
            const id_4 = (data[i+3]) ? data[i+3] : "";
            const id_5 = (data[i+4]) ? data[i+4] : "";

            return_content.push( <tr key={data[i].id}>
                <th scope="row">{data[i] ? i+1 : ''}</th>
                <td className="cursor-pointer" data-toggle="tooltip" data-placement="top" title={(data[i]) ? data[i].nama_pelanggan : ''} onClick={() => this.modalPing(id_1)}>{(data[i]) ? data[i].nama_pelanggan.substring(0, 15) + (data[i].nama_pelanggan.length > 15 ? '.....' : '') : ''}</td>
                <th scope="row">{(data[i]) ? <div className={'wd-15 ht-15 mg-l-10 rounded-circle ' + (data[i].status === 'AKTIF' ? 'bg-yellow-green' : 'bg-dark-red')}></div> : ''}</th>

                <th scope="row">{data[i+1] ? i+2 : ''}</th>
                <td className="cursor-pointer" data-toggle="tooltip" data-placement="top" title={(data[i+1]) ? data[i+1].nama_pelanggan : ''} onClick={() => this.modalPing(id_2)}>{(data[i+1]) ? data[i+1].nama_pelanggan.substring(0, 15) + (data[i].nama_pelanggan.length > 15 ? '.....' : '') : ''}</td>
                <th scope="row">{(data[i+1]) ? <div className={'wd-15 ht-15 mg-l-10 rounded-circle ' + (data[i+1].status === 'AKTIF' ? 'bg-yellow-green' : 'bg-dark-red')}></div> : ''}</th>

                <th scope="row">{data[i+2] ? i+3 : ''}</th>
                <td className="cursor-pointer" data-toggle="tooltip" data-placement="top" title={(data[i+2])? data[i+2].nama_pelanggan : ''} onClick={() => this.modalPing(id_3)}>{(data[i+2]) ? data[i+2].nama_pelanggan.substring(0, 15) + (data[i].nama_pelanggan.length > 15 ? '.....' : '') : ''}</td>
                <th scope="row">{(data[i+2]) ? <div className={'wd-15 ht-15 mg-l-10 rounded-circle ' + (data[i+2].status === 'AKTIF' ? 'bg-yellow-green' : 'bg-dark-red')}></div> : ''}</th>

                <th scope="row">{data[i+3] ? i+4 : ''}</th>
                <td className="cursor-pointer" data-toggle="tooltip" data-placement="top" title={(data[i+3]) ? data[i+3].nama_pelanggan : ''} onClick={() => this.modalPing(id_4)}>{(data[i+3]) ? data[i+3].nama_pelanggan.substring(0, 15) + (data[i].nama_pelanggan.length > 15 ? '.....' : '') : ''}</td>
                <th scope="row">{(data[i+3]) ? <div className={'wd-15 ht-15 mg-l-10 rounded-circle ' + (data[i+3].status === 'AKTIF' ? 'bg-yellow-green' : 'bg-dark-red')}></div> : ''}</th>

                <th scope="row">{data[i+4] ? i+5 : ''}</th>
                <td className="cursor-pointer" data-toggle="tooltip" data-placement="top" title={(data[i+4]) ? data[i+4].nama_pelanggan : ''} onClick={() => this.modalPing(id_5)}>{(data[i+4]) ? data[i+4].nama_pelanggan.substring(0, 15) + (data[i].nama_pelanggan.length > 15 ? '.....' : '') : ''}</td>
                <th scope="row">{(data[i+4]) ? <div className={'wd-15 ht-15 mg-l-10 rounded-circle ' + (data[i+4].status === 'AKTIF' ? 'bg-yellow-green' : 'bg-dark-red')}></div> : ''}</th>

                {/* <th scope="row">{data[i+5] ? i+6 : ''}</th>
                <td>{(data[i+5]) ? data[i+5].nama_pelanggan.substring(0, 15) + (data[i].nama_pelanggan.length > 15 ? '.....' : '') : ''}</td>
                <th scope="row">{(data[i+5]) ? <div className={'wd-15 ht-15 mg-l-10 rounded-circle ' + (data[i+5].status === 'AKTIF' ? 'bg-yellow-green' : 'bg-dark-red')}></div> : ''}</th>

                <th scope="row">{data[i+6] ? i+7 : ''}</th>
                <td>{(data[i+6]) ? data[i+6].nama_pelanggan.substring(0, 15) + (data[i].nama_pelanggan.length > 15 ? '.....' : '') : ''}</td>
                <th scope="row">{(data[i+6]) ? <div className={'wd-15 ht-15 mg-l-10 rounded-circle ' + (data[i+6].status === 'AKTIF' ? 'bg-yellow-green' : 'bg-dark-red')}></div> : ''}</th> */}

                {/* <th scope="row">{data[i+7] ? i+8 : ''}</th>
                <td>{(data[i+7]) ? data[i+7].nama_pelanggan.substring(0, 15) + (data[i].nama_pelanggan.length > 15 ? '.....' : '') : ''}</td>
                <th scope="row">{(data[i+7]) ? <div className={'wd-15 ht-15 mg-l-10 rounded-circle ' + (data[i+7].status === 'AKTIF' ? 'bg-yellow-green' : 'bg-dark-red')}></div> : ''}</th> */}
            </tr>)

        }
        return return_content;
    }

    render(){
        return(
            <div className="contact-wrapper">
                <Sidebar />
                <div className="filemgr-content">
                    <div className="chat-content-header" style={{marginTop: '-5px'}}>
                        <h6 id="channelTitle" className="mg-b-0">#DataStatusPekerjaan</h6>
                    </div>
                    <div className="filemgr-content-body" style={{backgroundColor: 'white'}} >
                        <div style={{maxWidth: "100%"}}>
                                {(this.state.loading) &&
                                    <div className="loader-spinner">
                                        <Loader
                                            type="Oval"
                                            color="#00BFFF"
                                            height={150}
                                            width={150}
                                            visible={this.state.loading}
                                            // timeout={3000} //3 secs
                                    
                                        /> 
                                    </div>
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered mg-b-0 table-sm" style={{fontSize: '8px'}}>
                                        <thead>
                                            <tr>
                                            <th scope="col" style={{width:'1%'}}>NO</th>
                                            <th scope="col" style={{width:'4%'}}>NAMA PELANGGAN</th>
                                            <th scope="col" style={{width:'1%'}}>STATUS</th>

                                            <th scope="col" style={{width:'1%'}}>NO</th>
                                            <th scope="col" style={{width:'4%'}}>NAMA PELANGGAN</th>
                                            <th scope="col" style={{width:'1%'}}>STATUS</th>

                                            <th scope="col" style={{width:'1%'}}>NO</th>
                                            <th scope="col" style={{width:'4%'}}>NAMA PELANGGAN</th>
                                            <th scope="col" style={{width:'1%'}}>STATUS</th>

                                            <th scope="col" style={{width:'1%'}}>NO</th>
                                            <th scope="col" style={{width:'4%'}}>NAMA PELANGGAN</th>
                                            <th scope="col" style={{width:'1%'}}>STATUS</th>

                                            <th scope="col" style={{width:'1%'}}>NO</th>
                                            <th scope="col" style={{width:'4%'}}>NAMA PELANGGAN</th>
                                            <th scope="col" style={{width:'1%'}}>STATUS</th>
                                            
                                            {/* <th scope="col" style={{width:'1%'}}>NO</th>
                                            <th scope="col" style={{width:'4%'}}>NAMA PELANGGAN</th>
                                            <th scope="col" style={{width:'1%'}}>STATUS</th>

                                            <th scope="col" style={{width:'1%'}}>NO</th>
                                            <th scope="col" style={{width:'4%'}}>NAMA PELANGGAN</th>
                                            <th scope="col" style={{width:'1%'}}>STATUS</th> */}

                                            {/* <th scope="col" style={{width:'1%'}}>NO</th>
                                            <th scope="col" style={{width:'4%'}}>NAMA PELANGGAN</th>
                                            <th scope="col" style={{width:'1%'}}>STATUS</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(this.state.data_pelanggan && !this.state.loading) &&
                                                this.generateContent()
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>   
                            <Modal show={this.state.modal_ping} onHide={() => this.setState({modal_ping : false})} animation={false} backdrop="static" keyboard={false} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>{this.state.nama_ping}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="input-group mg-b-10">
                                        <input type="text" className="form-control" readOnly value={this.state.alamat_ip_ping} aria-describedby="button-addon2" />
                                        <div className="input-group-append">
                                            <button className="btn btn-danger" type="button" id="button-addon2" onClick={() => this.checkPing()} disabled={(this.state.data_ping_5 === null  && this.state.loading_ping === true) ? true : false}>PING</button>
                                        </div>
                                    </div>
                                    <div className="df-example demo-table" style={{height:"200px"}}>
                                        {(this.state.data_ping_1) &&
                                        <div className="ml-3">
                                                <p className=" mg-b-10">{this.state.data_ping_1}</p>
                                                <p className=" mg-b-10">{this.state.data_ping_2}</p>
                                                <p className=" mg-b-10">{this.state.data_ping_3}</p>
                                                <p className=" mg-b-10">{this.state.data_ping_4}</p>
                                                <p className=" mg-b-10">{this.state.data_ping_5}</p>
                                            </div>
                                        }      
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-primary" type="button" onClick={() => this.setState({modal_ping : false})}>Close</button>
                                </Modal.Footer>
                            </Modal>  
                        </div>
                </div>
            </div>

        );
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        data_kategori : dataStore.getters.getDataKategori(),
        data_kategori_per : dataStore.getters.getDataKategoriPer(),
        data_klasifikasi : dataStore.getters.getDataKlasifikasi()
    }
}

export default connect(mapStateToProps)(Home);